import { Eye, EyeOff, LayoutDashboard, Layers, Check, Wine, UtensilsCrossed, Carrot,
  Users, Package, Truck, CalendarDays, Target, Calculator, BarChart3, Euro, Wallet, Building2
} from "lucide-react";
import { Button } from "../ui/button";
import { Switch } from "../ui/switch";

const DarstellungTab = ({ dashboardSettings, updateSetting, resetSettings, visibility, updateVisibility, resetVisibility, applyPreset }) => {
  return (
    <div className="space-y-6">
      {/* Dashboard Konfiguration */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-base font-semibold flex items-center gap-2 text-white">
            <LayoutDashboard size={18} className="text-blue-500" />
            Dashboard anpassen
          </h3>
          <Button variant="outline" size="sm" onClick={resetSettings} className="text-xs">
            Zurücksetzen
          </Button>
        </div>
        <p className="text-sm text-slate-400 mb-4">
          Wählen Sie, welche Karten auf dem Dashboard angezeigt werden sollen.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { key: "showSpeisen", label: "Speisen-Karte" },
            { key: "showGetraenke", label: "Getränke-Karte" },
            { key: "showMitarbeiter", label: "Mitarbeiter-Karte" },
            { key: "showFixkosten", label: "Fixkosten-Karte" },
            { key: "showGesamtkosten", label: "Gesamtkosten-Karte" },
            { key: "showKostenverteilung", label: "Kostenverteilungs-Rad" },
          ].map(({ key, label }) => (
            <div key={key} className="flex items-center justify-between p-3 bg-slate-700/50 rounded-lg">
              <div className="flex items-center gap-3">
                {dashboardSettings?.[key] ? <Eye size={16} className="text-green-500" /> : <EyeOff size={16} className="text-slate-400" />}
                <span className="text-sm font-medium text-white">{label}</span>
              </div>
              <Switch
                checked={dashboardSettings?.[key] ?? true}
                onCheckedChange={(checked) => updateSetting(key, checked)}
              />
            </div>
          ))}
        </div>

        <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
          <p className="text-xs text-blue-700 dark:text-blue-300">
            <Check size={12} className="inline mr-1" />
            Änderungen werden automatisch gespeichert und sofort auf dem Dashboard angezeigt.
          </p>
        </div>
      </div>

      {/* Modul-Sichtbarkeit */}
      <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-base font-semibold flex items-center gap-2">
            <Layers size={18} className="text-violet-500" />
            Module anpassen
          </h3>
          <Button variant="outline" size="sm" onClick={resetVisibility} className="text-xs">
            Alle anzeigen
          </Button>
        </div>
        <p className="text-sm text-slate-500 mb-4">
          Blenden Sie Module aus, die Sie nicht benötigen. Ideal für Bars ohne Speisekarte oder Cafés ohne Schichtplanung.
        </p>

        <div className="flex flex-wrap gap-2 mb-4">
          <Button variant="outline" size="sm" onClick={() => applyPreset('bar')} className="text-xs gap-1">
            <Wine size={12} /> Bar-Modus
          </Button>
          <Button variant="outline" size="sm" onClick={() => applyPreset('cafe')} className="text-xs gap-1">
            <UtensilsCrossed size={12} /> Café-Modus
          </Button>
          <Button variant="outline" size="sm" onClick={() => applyPreset('restaurant')} className="text-xs gap-1">
            <UtensilsCrossed size={12} /> Restaurant-Modus
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {[
            { key: "speisen", label: "Speisen", Icon: UtensilsCrossed },
            { key: "getraenke", label: "Getränke", Icon: Wine },
            { key: "zutaten", label: "Zutaten", Icon: Carrot },
            { key: "personal", label: "Personal", Icon: Users },
            { key: "fixkosten", label: "Fixkosten", Icon: Building2 },
            { key: "lager", label: "Lager", Icon: Package },
            { key: "lieferanten", label: "Lieferanten", Icon: Truck },
            { key: "schichtplan", label: "Schichtplan", Icon: CalendarDays },
            { key: "strategie", label: "Strategie", Icon: Target },
            { key: "preise", label: "Preisvorschläge", Icon: Calculator },
            { key: "statistik", label: "Statistik", Icon: BarChart3 },
            { key: "einnahmen", label: "Einnahmen", Icon: Euro },
            { key: "verdienst", label: "Verdienst", Icon: Wallet },
          ].map(({ key, label, Icon }) => (
            <div key={key} className="flex items-center justify-between p-3 bg-slate-50 dark:bg-slate-700/50 rounded-lg">
              <div className="flex items-center gap-3">
                <Icon size={16} className={visibility[key] ? "text-green-500" : "text-slate-400"} />
                <span className="text-sm font-medium">{label}</span>
              </div>
              <Switch checked={visibility[key]} onCheckedChange={(checked) => updateVisibility(key, checked)} data-testid={`module-${key}-toggle`} />
            </div>
          ))}
        </div>

        <div className="mt-4 p-3 bg-violet-50 dark:bg-violet-900/20 border border-violet-100 dark:border-violet-800 rounded-lg">
          <p className="text-xs text-violet-700 dark:text-violet-300">
            <Eye size={12} className="inline mr-1" />
            Ausgeblendete Module verschwinden aus der Navigation. Dashboard und Einstellungen bleiben immer sichtbar.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DarstellungTab;
